import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import Reservation from '../interfaces/Reservation'
import Vehicle from '../interfaces/Vehicle'
import useReservationFetcher from '../hooks/useReservationFetcher'
import useVehicleFetcher from '../hooks/useVehicleFetcher'
import useClientFetcher from '../hooks/useClientFetcher'
import Client from '../interfaces/Client'

import { Alert, Info } from './MessageInfo'
import SalenoteEdit from './SalenoteEdit'

const SalnoteCreFromRes: React.FC = () => {
  // Extracting id parameter from the route
  const { id } = useParams<{ id: string }>()
  const [reservation, setReservation] = useState<Reservation | null>(null)
  const { errorReservation, fetchReservation } = useReservationFetcher()

  const { errorVehicle, fetchVehicle } = useVehicleFetcher()
  const [vehicle, setVehicle] = useState<Vehicle>()
  const { errorClient, fetchClient } = useClientFetcher()
  const [client, setClient] = useState<Client>()

  const [infoMessage, setInfoMessage] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    fetchDataAsync()
  }, [id])

  const fetchDataAsync = async () => {
    if (!id || id === '') {
      return // Exit early if `id` is undefined
    }

    const reservation = await fetchReservation(id)
    const doc = 'reserva'

    if (errorReservation) {
      setErrorMessage(errorReservation.message)

      return
    }

    if (!reservation) {
      setErrorMessage(`Error recuperando la ${doc}`)

      return
    }

    // El vehiculo
    const vehicleId = reservation.vehicle
    const vehicle = await fetchVehicle(vehicleId)

    if (errorVehicle) {
      setErrorMessage(errorVehicle.message)

      return
    }

    if (!vehicle) {
      setErrorMessage('Error recuperando el vehículo')

      return
    }
    const clientId = reservation.client

    const client = await fetchClient(clientId)

    if (errorClient) {
      setErrorMessage(errorClient.message)

      return
    }

    if (!client) {
      setErrorMessage('Error recuperando el cliente')

      return
    }
    setClient(client)
    setVehicle(vehicle)
    setReservation(reservation)
  }

  const alertMessageTimeout = (): void => {
    setErrorMessage('')
  }

  const infoMessageTimeout = (): void => {
    setInfoMessage('')
  }

  return (
    <>
      {errorMessage !== '' && <Alert message={errorMessage} trigger={Date.now()} onTimeout={alertMessageTimeout} />}
      {infoMessage !== '' && <Info message={infoMessage} trigger={Date.now()} onTimeout={infoMessageTimeout} />}
      {/*preguntamos por reservation para que no parpadee */}
      {reservation && vehicle && client && (
        <div className="p-2 max-w-3xl mx-auto shadow-md">
          {/* Con el max-w-xl anterior le damnos un ancho extra large */}
          <SalenoteEdit vehicle={vehicle} client={client} reservation={reservation} />
        </div>
      )}
    </>
  )
}

export default SalnoteCreFromRes
